import React from 'react'
import { createGlobalStyle, css } from 'styled-components'
import { isInExtension } from '@mote/helpers/extension'

const GLOBAL_STYLES = css`
  :root {
    --color-primary: #ac0ae8;
    --color-secondary: #65008a;
  }

  *,
  *::before,
  *::after {
    border-width: 0;
    border-style: solid;
    box-sizing: border-box;
  }

  #root {
    height: 100%;
    overflow-x: hidden;
  }

  body {
    height: 100%;
    overflow-x: hidden;
    margin: 0;
    font-family: 'DM Sans', sans-serif !important;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-top: 0;
    margin-bottom: 0;
  }

  a {
    color: #232323;
    text-decoration: none;
    background-color: transparent;
    &:active,
    &:focus,
    &:hover {
      text-decoration: none;
      color: var(--color-primary);
    }
  }

  img,
  svg {
    vertical-align: initial;
  }

  ul {
    list-style: disc;
    padding-inline-start: 40px;
  }

  ol {
    list-style: decimal;
    padding-inline-start: 40px;
  }

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  button {
    background: transparent;
    padding: 0;
  }

  button,
  [role='button'] {
    cursor: pointer;
  }

  [hidden] {
    display: none !important;
  }

  [data-js-focus-visible] {
    & :focus:not([role='dialog']):not([data-focus-visible-added]),
    & [data-focus]:not([role='dialog']):not([data-focus-visible-added]) {
      outline: none;
      box-shadow: none;
    }
  }
`

const injectWebSpecificStyles = () => {
  const webSpecificStyles = css`
    ${GLOBAL_STYLES}

    html,
    body {
      height: 100%;
      overflow-x: hidden;
    }
  `

  return webSpecificStyles
}

const CustomGlobalStyles = createGlobalStyle`
  ${isInExtension() ? GLOBAL_STYLES : injectWebSpecificStyles()}
`

export const GlobalStyles = () => {
  return <CustomGlobalStyles />
}
